module.exports = __webpack_public_path__ + "img/left-arrow.39598f86.svg";